import type { Invitation, UserContactProfile } from "@dutyon/apis";
import { Badge, Button, Group, Paper, Table, Text } from "@dutyon/ui-kit";

interface CompanyInvitationListProps {
  invitations?: (Invitation & { invitee: UserContactProfile })[];
  formatDate: (date: Date | string) => string;
  onApprove: (id: string) => void;
  onReject: (id: string) => void;
}

export function CompanyInvitationList({
  invitations,
  formatDate,
  onApprove,
  onReject,
}: CompanyInvitationListProps) {
  return (
    <Paper withBorder p="md">
      {!invitations || invitations.length === 0 ? (
        <Text c="dimmed">초대 내역이 없습니다.</Text>
      ) : (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>초대 대상</Table.Th>
              <Table.Th>상태</Table.Th>
              <Table.Th>요청일</Table.Th>
              <Table.Th>관리</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {invitations.map((invitation) => (
              <Table.Tr key={invitation.id}>
                <Table.Td>
                  {invitation.invitee?.name} ({invitation.invitee?.email})
                </Table.Td>
                <Table.Td>
                  <Badge
                    color={
                      invitation.status === "APPROVED"
                        ? "blue"
                        : invitation.status === "REJECTED"
                          ? "red"
                          : "gray"
                    }
                  >
                    {invitation.status === "PENDING"
                      ? "승인 대기"
                      : invitation.status === "APPROVED"
                        ? "승인"
                        : invitation.status === "REJECTED"
                          ? "반려"
                          : "사용자 취소"}
                  </Badge>
                </Table.Td>
                <Table.Td>{formatDate(invitation.createdAt)}</Table.Td>
                <Table.Td>
                  {invitation.status === "PENDING" && (
                    <Group gap="xs">
                      <Button size="xs" variant="light" onClick={() => onApprove(invitation.id)}>
                        승인
                      </Button>
                      <Button
                        size="xs"
                        variant="light"
                        color="red"
                        onClick={() => onReject(invitation.id)}
                      >
                        거절
                      </Button>
                    </Group>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
}
